import { render } from "./responsive-video.vue?vue&type=template&id=41d42578"
import script from "./responsive-video.vue?vue&type=script&lang=js"
export * from "./responsive-video.vue?vue&type=script&lang=js"

import exportComponent from "/buddy/stephen-webster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__